import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { handleOpenMenu, handleOpenMenuMobile } from '../../entities/ComponentsSlice';
import { deviceSelector } from '../../entities/UserSlice';
import { useMenuService } from '../../tools/hooks/useMenuService';
import LoaderCircle from '../loader-circle/LoaderCircle';
import style from './ModalMenuRoutes.module.scss';

const ModalMenuRoutes = () => {
  const dispatch = useDispatch();
  const device = useSelector(deviceSelector);

  const { menuLeft, menuRight } = useMenuService();

  return (
    <>
      {menuLeft?.menuItems?.length > 0 && (
        <div className={style.modalMenuRoutes}>
          <div className={style.modalMenuRoutes__box}>
            {menuLeft?.menuItems?.map(el => {
              if (el.path.includes('contest'))
                return (
                  <div
                    key={el.path}
                    onClick={() =>
                      device !== 'isMobile' ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false))
                    }
                  >
                    <a href={el?.path} className={style.modalMenuRoutes__route}>
                      {el?.value}
                    </a>
                  </div>
                );
              return (
                <NavLink
                  key={el.path}
                  onClick={() =>
                    device !== 'isMobile' ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false))
                  }
                  className={style.modalMenuRoutes__route}
                  to={el?.path}
                >
                  {el?.value}
                </NavLink>
              );
            })}
          </div>
          <div className={style.modalMenuRoutes__box}>
            {menuRight?.menuItems?.map(el => {
              if (el.path.includes('contest'))
                return (
                  <div
                    key={el.path}
                    onClick={() =>
                      device !== 'isMobile' ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false))
                    }
                  >
                    <a href={el?.path} className={style.modalMenuRoutes__route}>
                      {el?.value}
                    </a>
                  </div>
                );
              return (
                <NavLink
                  key={el.path}
                  onClick={() =>
                    device !== 'isMobile' ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false))
                  }
                  className={style.modalMenuRoutes__route}
                  to={el?.path}
                >
                  {el?.value}
                </NavLink>
              );
            })}
          </div>
        </div>
      )}
      {menuLeft?.menuItems?.length === (0 || undefined) && (
        <div style={{ position: 'relative' }}>
          <LoaderCircle someStyles={style.loader} />
        </div>
      )}
    </>
  );
};

export default ModalMenuRoutes;
